import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../view/Login'
import Register from '../view/Register'
import Home from '../view/Home'
import OA from '../view/OA.vue';
import OAStartFlow from '../view/OAStartFlow.vue';
import OATaskList from '../view/OATaskList.vue';
import OAApprove from '../view/OAApprove.vue';
// 安装路由
Vue.use(VueRouter);

// 配置导出路由
export default new VueRouter({
  // 路由基座跟随打包基座，当前发布在站点根路径
  base: process.env.BASE_URL,
  mode: 'history', // 使用history模式
  routes: [{
    path: "/",
    redirect: "/login"
  },
  {
    name: "Login",
    path: '/login',
    component: Login
  },
  {
    name: "Register",
    path: '/register',
    component: Register
  },
  {
    name: "Home",
    path: '/home',
    component: Home,
    children: [
      {
        name: "Chat",
        path: "/home/chat",
        component: () => import("../view/Chat"),
      },
      {
        name: "Contact",
        path: "/home/contact",
        component: () => import("../view/Contact"),
      },
      {
        path: 'oa',
        name: 'oa',
        component: OA
      },
      {
        path: 'oa/start',
        name: 'oaStart',
        component: OAStartFlow
      },
      {
        path: 'oa/tasks',
        name: 'oaTasks',
        component: OATaskList
      },
      {
        path: 'oa/approve',
        name: 'oaApprove',
        component: OAApprove
      },
      {
        name: "Friend",
        path: "/home/friend",
        component: () => import("../view/Friend"),
      },
      {
        name: "FriendRequest",
        path: "/home/friend-request",
        component: () => import("../view/FriendRequest"),
      },
      {
        name: "BroadcastList",
        path: "/home/broadcast",
        component: () => import("../view/BroadcastList"),
      },
      {
        name: "BroadcastDetail",
        path: "/home/broadcast/:id",
        component: () => import("../view/BroadcastDetail"),
      },
      {
        name: "GROUP",
        path: "/home/group",
        component: () => import("../view/Group"),
      }
    ]
  }
  ]
});
